<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-sequence3-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-sequence3-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.67634038366945;"
    data-aspect-ratio="0.676"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-sequence3-xs-img"
      class="g-sequence3-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence3-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:3.7997%;margin-top:-8.5px;left:90.8579%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:5.7553%;margin-top:-9.1px;left:31.3528%;margin-left:-44.5px;width:89px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:21.7415%;margin-top:-9.1px;left:57.139%;width:138px;"
    >
      <p class="g-pstyle2">Reversing lights on</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:33.2188%;margin-top:-9.1px;left:28.7657%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle1">Wheel turning left</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:42.1137%;margin-top:-17.5px;left:48.5032%;margin-left:-149px;width:298px;"
    >
      <p class="g-pstyle3">
        Good&rsquo;s car starts reversing. ICE agent 1 circles
      </p>
      <p class="g-pstyle3">around the front of the car.</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:54.2178%;margin-top:-8.5px;left:91.2251%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:56.3783%;margin-top:-9.1px;left:29.7849%;margin-left:-44.5px;width:89px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:73.7992%;margin-top:-9.1px;left:59.4374%;width:139px;"
    >
      <p class="g-pstyle2">Reversing lights off</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:81.0545%;margin-top:-17.5px;right:58.1064%;width:151px;"
    >
      <p class="g-pstyle4">Agent reaches into</p>
      <p class="g-pstyle4">Good&rsquo;s open window.</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:92.5318%;margin-top:-17.5px;left:48.4647%;margin-left:-92px;width:184px;"
    >
      <p class="g-pstyle3">Wheel begins turning right</p>
      <p class="g-pstyle3">as car moves forward.</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-sequence3-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.04525332021643;"
    data-aspect-ratio="1.045"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-sequence3-sm-img"
      class="g-sequence3-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence3-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:3.7997%;margin-top:-8.5px;left:84.9669%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:5.7553%;margin-top:-9.1px;left:37.6402%;margin-left:-44.5px;width:89px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:21.7415%;margin-top:-9.1px;left:54.3252%;width:138px;"
    >
      <p class="g-pstyle2">Reversing lights on</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:33.2188%;margin-top:-9.1px;left:35.966%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle1">Wheel turning left</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:42.1137%;margin-top:-17.5px;left:48.7374%;margin-left:-149px;width:298px;"
    >
      <p class="g-pstyle3">
        Good&rsquo;s car starts reversing. ICE agent 1 circles
      </p>
      <p class="g-pstyle3">around the front of the car.</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:54.2178%;margin-top:-8.5px;left:85.2045%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:56.3783%;margin-top:-9.1px;left:36.6255%;margin-left:-44.5px;width:89px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:73.7992%;margin-top:-9.1px;left:55.8125%;width:139px;"
    >
      <p class="g-pstyle2">Reversing lights off</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:81.0545%;margin-top:-17.5px;right:55.5394%;width:151px;"
    >
      <p class="g-pstyle4">Agent reaches into</p>
      <p class="g-pstyle4">Good&rsquo;s open window.</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:92.5318%;margin-top:-17.5px;left:48.7125%;margin-left:-92px;width:184px;"
    >
      <p class="g-pstyle3">Wheel begins turning right</p>
      <p class="g-pstyle3">as car moves forward.</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-sequence3-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.35268076733891;"
    data-aspect-ratio="1.353"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-sequence3-md-img"
      class="g-sequence3-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence3-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:3.8167%;margin-top:-9.6px;left:76.0855%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:5.5673%;margin-top:-10.2px;left:39.7532%;margin-left:-49px;width:98px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:21.7584%;margin-top:-10.2px;left:52.6864%;width:155px;"
    >
      <p class="g-pstyle2">Reversing lights on</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:33.2357%;margin-top:-10.2px;left:38.449%;margin-left:-73.5px;width:147px;"
    >
      <p class="g-pstyle1">Wheel turning left</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:42.9915%;margin-top:-19.8px;left:48.4106%;margin-left:-169px;width:338px;"
    >
      <p class="g-pstyle3">
        Good&rsquo;s car starts reversing. ICE agent 1 circles
      </p>
      <p class="g-pstyle3">around the front of the car.</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:54.2348%;margin-top:-9.6px;left:76.2689%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:56.1904%;margin-top:-10.2px;left:38.9691%;margin-left:-49px;width:98px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:73.6112%;margin-top:-10.2px;left:53.8357%;width:156px;"
    >
      <p class="g-pstyle2">Reversing lights off</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:81.3175%;margin-top:-19.8px;right:54.9944%;width:169px;"
    >
      <p class="g-pstyle4">Agent reaches into</p>
      <p class="g-pstyle4">Good&rsquo;s open window.</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:93.6145%;margin-top:-19.8px;left:48.4101%;margin-left:-104px;width:208px;"
    >
      <p class="g-pstyle3">Wheel begins turning right</p>
      <p class="g-pstyle3">as car moves forward.</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-sequence3-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 3.875;"
    data-aspect-ratio="3.875"
    data-min-width="930"
  >
    <div
      id="g-sequence3-lg-img"
      class="g-sequence3-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence3-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.9261%;margin-top:-9.6px;left:45.4469%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.9261%;margin-top:-9.6px;left:94.1229%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:10.485%;margin-top:-10.2px;left:19.5552%;margin-left:-49px;width:98px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:10.9017%;margin-top:-10.2px;left:67.3295%;margin-left:-49px;width:98px;"
    >
      <p class="g-pstyle1">ICE agent 1</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:43.4016%;margin-top:-10.2px;left:28.411%;width:155px;"
    >
      <p class="g-pstyle2">Reversing lights on</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:46.3183%;margin-top:-10.2px;left:77.8799%;width:156px;"
    >
      <p class="g-pstyle2">Reversing lights off</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:61.9851%;margin-top:-19.8px;right:28.3866%;width:169px;"
    >
      <p class="g-pstyle3">Agent reaches into</p>
      <p class="g-pstyle3">Good&rsquo;s open window.</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:66.7349%;margin-top:-10.2px;left:13.3801%;width:147px;"
    >
      <p class="g-pstyle2">Wheel turning left</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:86.985%;margin-top:-19.8px;left:24.4372%;margin-left:-169px;width:338px;"
    >
      <p class="g-pstyle4">
        Good&rsquo;s car starts reversing. ICE agent 1 circles
      </p>
      <p class="g-pstyle4">around the front of the car.</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:86.985%;margin-top:-19.8px;left:74.0012%;margin-left:-104px;width:208px;"
    >
      <p class="g-pstyle4">Wheel begins turning right</p>
      <p class="g-pstyle4">as car moves forward.</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-08 17:48 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-08 17:48 -->
<!-- ai file: sequence3.ai -->
<style lang="scss">
  #g-sequence3-box {
    container-type: inline-size;
    container-name: g-sequence3-box;
  }
  #g-sequence3-box,
  #g-sequence3-box .g-artboard {
    margin: 0 auto;
  }
  #g-sequence3-box p {
    margin: 0;
  }
  #g-sequence3-box .g-aiAbs {
    position: absolute;
  }
  #g-sequence3-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-sequence3-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-sequence3-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence3-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence3-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-sequence3-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-sequence3-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-sequence3-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-sequence3-lg {
        display: block !important;
      }
    }
  }
  #g-sequence3-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence3-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence3-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-sequence3-xs .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-xs .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-xs .g-pstyle3 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-sequence3-xs .g-pstyle4 {
    font-weight: 700;
    height: 17px;
    text-align: right;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence3-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence3-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-sequence3-sm .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-sm .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-sm .g-pstyle3 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-sequence3-sm .g-pstyle4 {
    font-weight: 700;
    height: 17px;
    text-align: right;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence3-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence3-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-sequence3-md .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-md .g-pstyle2 {
    font-weight: 700;
    height: 19px;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-md .g-pstyle3 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }
  #g-sequence3-md .g-pstyle4 {
    font-weight: 700;
    height: 19px;
    text-align: right;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence3-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence3-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-sequence3-lg .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-lg .g-pstyle2 {
    font-weight: 700;
    height: 19px;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-lg .g-pstyle3 {
    font-weight: 700;
    height: 19px;
    text-align: right;
    color: rgb(255, 212, 48);
  }
  #g-sequence3-lg .g-pstyle4 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
  .g-timestamp {
    background-color: rgba(34, 34, 34);
    padding: 1px 3px;
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
  }
</style>
